import { render, staticRenderFns } from "./SnsFixed.vue?vue&type=template&id=407d0f3b&scoped=true"
import script from "./SnsFixed.vue?vue&type=script&lang=js"
export * from "./SnsFixed.vue?vue&type=script&lang=js"
import style0 from "./SnsFixed.vue?vue&type=style&index=0&id=407d0f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d0f3b",
  null
  
)

export default component.exports